/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Varietal_PlaceholderInputs */

const en_search_varietal_placeholder = /** @type {(inputs: Search_Varietal_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search varietal...`)
};

const es_search_varietal_placeholder = /** @type {(inputs: Search_Varietal_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar varietal...`)
};

/**
* | output |
* | --- |
* | "Search varietal..." |
*
* @param {Search_Varietal_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_varietal_placeholder = /** @type {((inputs?: Search_Varietal_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Varietal_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_varietal_placeholder(inputs)
	return es_search_varietal_placeholder(inputs)
});